import { forwardRef } from "react";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Button, type ButtonSize, type ButtonVariant } from "./Button";

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  label: string;
  icon: ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
}

/** Square icon-only button — always carries an aria-label per DESIGN.md §12. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton({ label, icon, variant = "ghost", size = "md", className, ...props }, ref) {
  return (
    <Button ref={ref} aria-label={label} variant={variant} size={size} iconOnly className={className} {...props}>
      {icon}
    </Button>
  );
});
